import {Injectable} from '@angular/core';
import {AngularFirestore, AngularFirestoreDocument} from '@angular/fire/compat/firestore';
import {AngularFireStorage} from '@angular/fire/compat/storage';
import {AngularFireFunctions} from '@angular/fire/compat/functions';
import {Regional} from '../models/regional';
import {map, Observable} from 'rxjs';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';

@Injectable({
  providedIn: 'root'
})
export class RegionalService {

  public objectImage: any = null; // store input file for avatar
  public storedImage: any; // store url image for local preview

  private itemDoc: AngularFirestoreDocument<Regional>;
  private item: Observable<Regional>;

  constructor (private db: AngularFirestore,
    private fs: AngularFireStorage,
    private ff: AngularFireFunctions,
    private snackBar: SnackBarIconService) { }

  select () {
    return this.db.collection<Regional>('sbccv_regionals', ref => ref.orderBy('name', 'asc')).snapshotChanges();
  }

  load () {
    return this.db.collection<Regional>('sbccv_regionals', ref => ref
      .orderBy('name', 'asc'))
      .snapshotChanges()
      .pipe(
        map(actions => actions.map(a => {
          const data = a.payload.doc.data() as any;
          const id = a.payload.doc.id;
          return {
            ...data,
            id,
          } as Regional;
        }))
      );
  }

  selectById (id) {
    this.itemDoc = this.db.doc<Regional>('sbccv_regionals/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  insert (entity: Regional) {
    //return this.db.collection('sbccv_regionals').add(Object.assign({}, entity));
    return this.db.collection('sbccv_regionals').doc(entity.short).set(Object.assign({}, entity));

  }

  update (entity: Regional) {
    return this.db.collection('sbccv_regionals').doc(entity.id).set(Object.assign({}, entity));
  }

  delete (entity_id: any) {
    return this.db.collection('sbccv_regionals').doc(entity_id).delete();
  }

  makeMsgError (errorsCode) {
    let msgError: string

    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
    }

    return msgError
  }

}
